import { CardModel, PileCardModel } from "../../interface/game";
import { PileDropPolicy } from "./pile-drop-policy";

export class PileDropAnyPolicy implements PileDropPolicy {
    canDrop(pile: PileCardModel[], dropCards: PileCardModel[], cards: {[key: string]: CardModel}): boolean {
        return true;
    }
}